const userGroupAutomatedMembers = {
  name: 'UserGroupAutomatedMembers',
  text: 'All new! Automate user group membership using membership suggestion conditions. See',
  learnMoreText: 'Advanced Configurations: Group Membership Automation',
  learnMoreLink: 'https://support.jumpcloud.com/s/article/Advanced-Configurations-Group-Membership-Automation',
};

const userGroupSudoBanner = {
  name: 'UserGroupSudoBanner',
  text: 'You can set individual permissions on device groups bound to existing user groups. ',
  learnMoreText: 'Check more details here',
  learnMoreLink: 'https://jumpcloud-support.force.com/support/s/article/setting-sudoadministrator-permissions2',
};

export default {
  userGroupAutomatedMembers,
  userGroupSudoBanner,
};
